import { Maybe, SelectedConfigurableOption } from "@graphcommerce/graphql-mesh"
import Image from "next/image";
import { useState } from "react";

type ShowSwatchColorsOnPLPType = {
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
}





function ShowSwatchColorsOnPLP(props: ShowSwatchColorsOnPLPType) {
  const [count, setCount] = useState<string[]>([])

  if (props?.configurable_options?.length && props?.configurable_options?.length > 0)
    props?.configurable_options?.map(option => option?.values?.map(item => {
      if (item?.swatch_data && item?.swatch_data?.__typename === "ImageSwatchData") {
        count.push(item?.swatch_data?.thumbnail as string);
      }
      return null;
    }))

  return (<div className="w-full flex flex-col gap-1 justify-center">
    {count.map((item, index) => {
      if (index < 4)
        return <Image src={item} width={10} height={10} alt='' className="rounded-[50%]" />
      if (index === 5)
        return <p className="w-[20px] h-[20px] border border-[#ddd] rounded-full" >{`${count.length - 4}+`} </p>
      return null;
    })}
  </div>)
}

// eslint-disable-next-line import/no-default-export
export default ShowSwatchColorsOnPLP;

